import axios from "axios"

const surveyInstance = axios.create({
	baseURL: process.env.REACT_APP_MIS_BASE_URL,
});

export const surveyUATInstance = axios.create({
	baseURL: process.env.REACT_APP_SURVEY_BASE_URL,
});

export const ppmvInstance = axios.create({
	baseURL: process.env.REACT_APP_PPMV_BASE_URL
});

export const cloudinaryInstance = axios.create({
	baseURL: process.env.REACT_APP_CLOUDINARY_URL,
});

export default surveyInstance
